import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from '../store/hooks'
import { useGetMeQuery } from '../store/api'
import { setInitialized } from '../store/authSlice'

interface ProtectedRouteProps {
	children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const dispatch = useAppDispatch()
	const token = useAppSelector((state) => state.auth.token)
	const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated)
	const isInitialized = useAppSelector((state) => state.auth.isInitialized)

	const { isError } = useGetMeQuery(undefined, {
		skip: !token || isInitialized,
	})

	useEffect(() => {
		if (!isInitialized && !token) {
			dispatch(setInitialized(true))
		}
	}, [isInitialized, token, dispatch])

	if (!isInitialized) {
		return (
			<div className="d-flex justify-content-center align-items-center min-vh-100">
				<Spinner animation="border" role="status" />
			</div>
		)
	}

	if (!token || !isAuthenticated || isError) {
		return <Navigate to="/login" replace />
	}

	return <>{children}</>
}

export default ProtectedRoute

